import { useQuery } from '@tanstack/react-query'
import { OpalApiRequestParams, OpalApiResponseDocument } from '@opallabs/api'
import { blocks } from '../../../BFF'
import { globalQueryKeys } from '../../queryKeys'

type ReadBlocksResponse = OpalApiResponseDocument<'ReadBlocksBFFV1', 200>

type BlockssQuery = OpalApiRequestParams<'ReadBlocksBFFV1'>['query']

export type UseReadBlocksParams = {
  enabled?: boolean
  filter: OpalApiRequestParams<'ReadBlocksBFFV1'>['query']['filter']
  workspaceUuid: string
}

type UseReadViewsOptions<T = ReadBlocksResponse> = UseReadBlocksParams & {
  select?: (data: ReadBlocksResponse) => T
}

export const getReadBlocksQueryFn = (
  query: BlockssQuery,
  workspaceUuid: string
) => {
  return () =>
    blocks.readCollection({
      params: {
        path: {
          workspace_id: workspaceUuid,
        },
        query,
      },
    })
}

export const useReadBlocks = <T = ReadBlocksResponse>({
  enabled,
  filter,
  select,
  workspaceUuid,
}: UseReadViewsOptions<T>) => {
  const query: BlockssQuery = {
    filter,
  }

  return useQuery({
    enabled,
    queryKey: globalQueryKeys.blocksByWorkspace(workspaceUuid, query),
    queryFn: getReadBlocksQueryFn(query, workspaceUuid),
    select,
  })
}
